'use client';

import StoreBadgeLinks from '@/components/common/app-download/StoreBadgeLinks';
import {
  ZANGIA_APP_STORE_URL,
  ZANGIA_PLAY_STORE_URL,
} from '@/lib/app-download/constants';
import { useAppDownloadConfig } from '@/lib/app-download/app-download.queries';

type FooterStoreBadgeLinksProps = {
  className?: string;
  badgeWidth?: number;
  badgeHeight?: number;
};

export default function FooterStoreBadgeLinks(props: FooterStoreBadgeLinksProps) {
  const { data } = useAppDownloadConfig('zangia');

  const iosUrl = data?.stores?.ios?.url ?? ZANGIA_APP_STORE_URL;
  const androidUrl = data?.stores?.android?.url ?? ZANGIA_PLAY_STORE_URL;

  return <StoreBadgeLinks iosUrl={iosUrl} androidUrl={androidUrl} {...props} />;
}
